import { render, staticRenderFns } from "./exhibition-layout.vue?vue&type=template&id=1184fbd2&scoped=true&"
import script from "./exhibition-layout.vue?vue&type=script&lang=js&"
export * from "./exhibition-layout.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-layout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-layout.vue?vue&type=style&index=1&id=1184fbd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184fbd2",
  null
  
)

export default component.exports